export interface IconPickerValue {
  name: string;
  type: string;
  theme: string;
};
